import { Component, OnInit } from '@angular/core';
import {faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';



@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  // Social Media Icons
  faFacebook = faFacebook
  faTwitter = faTwitter
  faInstagram = faInstagram
  faLinkedin = faLinkedin

  constructor() { }

  ngOnInit(): void {
  }

}
